import React, { Component, Fragment } from "react";
import VaccineCenter from "./VaccineCenter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getVaccineCenters } from "../../actions/vaccinecenterActions";
import VCForm from "./VCForm";
import VCFilter from "./VCFilter";

class VaccineCenters extends Component {
  componentDidMount() {
    this.props.getVaccineCenters();
  }

  render() {
    const { vaccinecenters } = this.props;
    const count = vaccinecenters.length;
    return (
      <Fragment>
        <VCForm />
        {/* <VCFilter /> */}
        <h4 className="my-4 ">COVID-19 Vaccine Centers</h4>
        <p>There are {count} Vaccine Centers Near You</p>
        {vaccinecenters.reverse().map((vaccinecenter) => (
          <VaccineCenter
            key={vaccinecenter._id}
            vaccinecenter={vaccinecenter}
          />
        ))}
        {count < 6 ? (
          <a className="btn btn-primary btn-block my-4" href="/">
            Show All
          </a>
        ) : null}
      </Fragment>
    );
  }
}
VaccineCenters.propTypes = {
  vaccinecenters: PropTypes.array.isRequired,
  getVaccineCenters: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  vaccinecenters: state.vaccinecenter.vaccinecenters,
});

export default connect(mapStateToProps, {
  getVaccineCenters,
})(VaccineCenters);
